var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tablePageComp',{attrs:{"columnsList":_vm.columnsList,"dataList":_vm.dataList,"orderNumConfig":{},"getDataConfig":_vm.dataQueryFunc(),"updateDataTag":_vm.updateDataTag,"totalCount":_vm.total}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }